<script lang="ts" setup>
    import type { BikeDetailInfo } from '~/@types/product';

    interface ProductCardBikeDetailsProps {
        bikeDetail: BikeDetailInfo;
    }
    defineProps<ProductCardBikeDetailsProps>();
</script>
<template>
    <div>
        <span class="sr-only">{{ bikeDetail.wheels?.label }}</span>
        {{ bikeDetail.wheels?.value }} • {{ bikeDetail.weight?.value }} • {{ bikeDetail.age?.label }} {{ bikeDetail.age?.value }} •
        {{ bikeDetail.size?.value }}
    </div>
</template>
